import { css } from "lit";
// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{display:flex;flex-direction:column;overflow:hidden}#tablist{background:var(--color-background-secondary);border-bottom:1px solid var(--color-border-primary);display:flex;flex-shrink:0;gap:.5rem;overflow-x:auto}`, ""]);
// Exports
export default css([___CSS_LOADER_EXPORT___.toString()]);
